var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXiaZai(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u4E0B\u8F7D") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u7701\\u5385\\u540E\\u53F0",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5\\u4F5C\\u54C1\\u7BA1\\u7406-\\u5168\\u90E8\\u4F5C\\u54C1",
    transform: "translate(-1619, -181)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-8",
    transform: "translate(1584, 165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u4E0B\\u8F7D",
    transform: "translate(35, 16)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    opacity: 0,
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5714219,11.7142812 L12.5714219,12.5714219 C12.5714219,12.7292139 12.4435108,12.857132 12.2857188,12.8571406 L3.71428125,12.8571406 C3.55648924,12.857132 3.42857812,12.7292139 3.42857812,12.5714219 L3.42857812,11.7142813 C3.42857812,11.0830974 2.91690255,10.5714219 2.28571875,10.5714219 L1.14285938,10.5714219 C0.511675571,10.5714219 0,11.0830974 0,11.7142812 L0,14.2857187 C0,15.2324901 0.767509859,16 1.71428125,16 L14.2857188,16 C15.2324901,16 16,15.2324901 16,14.2857187 L16,11.7142812 C16,11.0830974 15.4883244,10.5714219 14.8571406,10.5714219 L13.7142813,10.5714219 C13.0830974,10.5714219 12.5714219,11.0830974 12.5714219,11.7142813 L12.5714219,11.7142812 Z",
    id: "\\u8DEF\\u5F84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,5.52285938 L10,1.14285938 C10,0.839754223 9.87959195,0.549063469 9.66526424,0.334735761 C9.45093653,0.120408053 9.16024578,0 8.85714062,0 L7.14285938,0 C6.51167557,0 6,0.511675571 6,1.14285938 L6,5.52285938 C6,5.68065748 5.87207936,5.80857813 5.71428125,5.80857813 L4.37714063,5.80857813 C4.15519723,5.80950095 3.95386496,5.93885629 3.86078009,6.14033813 C3.76769521,6.34181996 3.79969845,6.57897661 3.94285938,6.74857813 L7.56571875,11.0114063 C7.67419359,11.1344077 7.83028859,11.2048725 7.99428906,11.2048725 C8.15828953,11.2048725 8.31438453,11.1344077 8.42285937,11.0114063 L12.0571406,6.74859375 C12.2003016,6.57899224 12.2323048,6.34183559 12.1392199,6.14035375 C12.046135,5.93887192 11.8448028,5.80951658 11.6228594,5.80859375 L10.2857187,5.80859375 C10.2099387,5.80859375 10.1372627,5.77848918 10.0836796,5.72490314 C10.0300965,5.6713171 9.99999586,5.59863941 10,5.52285938 L10,5.52285938 Z",
    id: "\\u8DEF\\u5F84"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXiaZai);
export default __webpack_public_path__ + "static/media/xiaZai.dbde37df7899f0e7659d34099a354c8b.svg";
export { ForwardRef as ReactComponent };